import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications'
import {
  Box,
  Collapse,
  Grid,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography
} from '@mui/material'
import { ReactElement, useMemo, useState } from 'react'

import { EntryWithRelated } from '../../models/inspections'
import {
  InspectionEntryServiceEntry,
  ServiceEntry,
  ServiceExpanded,
  ServiceInfoStatusEnum
} from '../../sdk'
import MediaGalleryReadOnly from '../MediaGallery/MediaGalleryReadOnly'
import { mapServiceAssociations } from './mapServiceAssociations'
import ServiceListItem from './ServiceListItem'
import SingleEntryPromptItem from './SingleEntryPromptItem'
export interface EditEntryProps {
  services: ServiceExpanded[] | undefined
  associations: InspectionEntryServiceEntry[] | undefined
  handleDeferOrRecommendService?: (
    service: ServiceEntry,
    isDeferral: boolean
  ) => Promise<void>
  entry: EntryWithRelated
  showPrice: boolean
}
const SingleEntryUIForCustomer: (props: EditEntryProps) => ReactElement = ({
  entry,
  showPrice,
  handleDeferOrRecommendService,
  services,
  associations
}) => {
  const [open, setOpen] = useState(true)
  const filteredAssociations = useMemo(() => {
    return services && mapServiceAssociations(entry, services, associations)
  }, [entry, services, associations])

  const filteredServices = useMemo(
    () =>
      (filteredAssociations || [])
        .filter((association) => association.checked)
        .map((association) => association.service)
        .filter(
          (service) =>
            service.entry!.info?.status === ServiceInfoStatusEnum.Recommended ||
            service.entry!.info?.status === ServiceInfoStatusEnum.Deferred
        ),
    [filteredAssociations]
  )

  if (entry.prompts.length === 0) {
    return <></>
  }
  const prompt = entry.prompts[0]
  const media = prompt.media!.filter((m) => m.mediaUrl)
  return (
    <Box sx={{ border: '1px solid rgba(0, 0, 0, 0.24)', borderRadius: 2 }}>
      <ListItemButton onClick={() => setOpen(!open)}>
        <ListItemIcon>
          <SettingsApplicationsIcon />
        </ListItemIcon>
        <ListItemText
          primary={
            <Typography variant="h5" color="primary.main">
              {entry.info!.title || '(No title)'}
            </Typography>
          }
        />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit sx={{ pr: 2, pl: 2 }}>
        <Grid container direction="row" alignItems="center">
          <Grid item xs={6}>
            <List sx={{ bgcolor: 'background.paper' }}>
              <SingleEntryPromptItem prompt={prompt} key={prompt.id} />
            </List>
          </Grid>
          <Grid item xs={6}>
            <Typography>{entry.info!.customerNotes}</Typography>
          </Grid>
        </Grid>
        {media.length > 0 && (
          <Grid item xs={12}>
            <MediaGalleryReadOnly media={media} />
          </Grid>
        )}
        <List sx={{ bgcolor: 'background.paper', p: 0 }}>
          {filteredServices.map((service) => (
            <ServiceListItem
              key={service.entry?.id}
              service={service}
              showPrice={showPrice}
              isCustomerVersion={true}
              handleDeferOrRecommendService={handleDeferOrRecommendService}
            />
          ))}
        </List>
      </Collapse>
    </Box>
  )
}

export default SingleEntryUIForCustomer
